export const HOST_DEV = "https://ghidini.dcoworks.com";

export const API_KEY = "yRQapLAMYZp8N4I3utSylwKLYeFandjL1NYr"

export const API_BASE_URL = `/api`
export const API_BASE_URL_V = `${API_BASE_URL}/v1`

export const API_QUESTIONNAIRES =  `${API_BASE_URL_V}/questionnaires`
